import { Stack } from '@mui/material';
import * as R from 'ramda';
import { ReactNode, memo } from 'react';
import Typography from '../../../../../../../../../../components/Typography/Typography';
import useGetGridItemWidth from '../../../../../../../../../../hooks/useGetGridItemWidth';
import HorizontalScroll from '../../../../components/HorizontalScroll/HorizontalScroll';
import { SelloutRowItem } from '../../../types/selloutRows.types';

interface SelloutRowMobileProps {
  title: string;
  subtitle?: string;
  total?: number;
  data: SelloutRowItem[];
  ExtraInput?: ReactNode;
  renderItem?: (item: SelloutRowItem) => ReactNode;
}

const SelloutRowMobile = ({
  title,
  subtitle,
  total,
  data,
  ExtraInput = null,
  renderItem,
}: SelloutRowMobileProps) => {
  const { gridItemWidth } = useGetGridItemWidth();

  return (
    <Stack spacing="16px">
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Stack spacing="4px">
          <Typography variant="body1.5-medium">{title}</Typography>
          {subtitle && (
            <Typography color="textSecondary" variant="body3-regular" noWrap>
              {subtitle}
            </Typography>
          )}
        </Stack>

        {ExtraInput}

        {!R.isNil(total) && <Typography>{total}</Typography>}
      </Stack>
      <HorizontalScroll>
        <Stack
          direction="row"
          sx={{
            marginLeft: '-28px',
          }}
        >
          {data.map((item) => (
            <Stack
              key={item.skuId}
              spacing="8px"
              sx={{
                width: gridItemWidth,
                alignItems: 'center',
              }}
            >
              <Typography noWrap color="textSecondary">
                {item.sizeName}
              </Typography>

              {!R.isNil(item.value) && <Typography noWrap>{item.value}</Typography>}

              {renderItem && renderItem(item)}
            </Stack>
          ))}
        </Stack>
      </HorizontalScroll>
    </Stack>
  );
};

export default memo(SelloutRowMobile);
